import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import resources from 'app/store/resources';
import uniqid from 'app/libs/uniqid.js';
import classes from 'app/pages/Notifications/ManageSubscriptions/ManageSubscriptions.module.scss';
import Widget from 'app/components/Widget/Widget.jsx';
import { confirm } from 'app/components/Modal';
import { ModulableTree } from 'app/components/ModulableTree/ModulableTree.jsx';
import PaginatedComponent from 'app/components/PaginatedComponent/PaginatedComponent.jsx';
import { getActionObjectTypeIdentifier, functionsByContentType } from 'app/core/utils/contentTypesUtils';
import { getStatusRequest } from 'app/store/resources/utils/getStatusRequest';
import { activeUserSelector } from 'app/store/selectors/user';
import { getResources } from 'app/store/selectors/getResources';
const subscriptionsPaginatedList = uniqid('subscriptions-');
export default function ManageSubscriptions() {
    const [isLoading, setIsLoading] = useState(false);
    const { paginatedLists } = useSelector((state) => state.subscriptions);
    const paginatedList = paginatedLists[subscriptionsPaginatedList];
    const [subscriptions, setSubscriptions] = useState([]);
    const [count, setCount] = useState(0);
    const userId = useSelector(activeUserSelector);
    useEffect(() => {
        const load = getStatusRequest('subscriptions', 'fetchAllUserSubscriptions');
        setIsLoading(load.pending);
        const getSubscriptions = Object.values(getResources(undefined, `subscriptions.paginatedLists.${subscriptionsPaginatedList}`));
        setSubscriptions(getSubscriptions);
        if (paginatedList)
            setCount(paginatedList.count);
    }, [paginatedList]);
    function onRequestNeeded(pageSize, currentPage) {
        resources.subscriptions.fetchAllUserSubscriptions(userId, {
            params: {
                queries: {
                    page_size: pageSize,
                    page: currentPage,
                },
            },
            paginatedList: subscriptionsPaginatedList,
        });
    }
    function onClickDeleteSubscription(subscription) {
        const label = functionsByContentType[getActionObjectTypeIdentifier(subscription.targetType, subscription.verb)].getFeedName(subscription.target);
        confirm({
            title: 'Unsubscribe',
            render: (_jsxs("div", { children: ["Do you want to unsubscribe to ", _jsx("b", { children: label }), " ?"] })),
            validateLabelColor: '#E56D7A',
            validateLabel: 'Unsubscribe',
            onValidate: () => {
                return resources.subscriptions.delete(subscription.id, { paginatedList: subscriptionsPaginatedList });
            },
        });
    }
    function renderSubscriptions() {
        const items = subscriptions.map((subscription) => ({
            key: subscription.id,
            value: subscription,
            label: functionsByContentType[getActionObjectTypeIdentifier(subscription.targetType, subscription.verb)].labelFeed(subscription.target),
            actions: [
                {
                    key: 'delete',
                    onClick: () => onClickDeleteSubscription(subscription),
                },
            ],
        }));
        return (_jsx("div", { style: { overflowY: 'auto' }, children: _jsx(ModulableTree, { items: items, noItemsLabel: "No notifications", treeProps: { classes } }) }));
    }
    return (_jsx(Widget, { style: { margin: '0 auto', height: '100%', width: '100%' }, children: _jsx(PaginatedComponent, { count: count, renderChildren: renderSubscriptions, isLoading: isLoading, onRequestNeeded: onRequestNeeded }) }));
}
